<template>
    <div class="profile-page">
        <section class="section-profile-cover section-shaped my-0">
            <div class="shape shape-style-1 shape-primary shape-skew alpha-4">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
        </section>
        <section class="section section-skew">
            <div class="container">
                <card shadow class="card-profile mt--300" no-body>
                    <div class="px-4">
                        <div class="text-center mt-5">
                            <h3>오시는 길</h3>
                        </div>
                        <div class="mt-5 py-5 border-top text-center">
                            <div class="row text-left">
                                <div class="col">
                                    <div class="h3 font-weight-300">
                                        동작 본사
                                    </div>
                                </div>
                                <div class="col-lg-5">
                                    <p>
                                        <span class="btn-ad">주소</span>
                                        &nbsp;서울특별시 동작구 현충로 153 상가동 211호 (주)다옴토건
                                    </p>
                                    <p>
                                        <span class="btn-ad">전화</span>
                                        &nbsp;02-3280-2825
                                    </p>
                                </div>
                                <div class="col-lg-5">
                                    <p>
                                        <span class="btn-ad">오시는 법</span>
                                        &nbsp;<a href="https://me2.do/Gal6uDwp" target="_blank"><span class="btn-naver bg-line-4">동작역</span></a>
                                        &nbsp;<a href="https://me2.do/5ISypKX6" target="_blank"><span class="btn-naver bg-line-9">흑석역</span></a>

                                    </p>
                                    <p>
                                        &nbsp;지하철 4호선 동작역 (9번 출구) 도보 10분 소요
                                        <br>&nbsp;지하철 9호선 흑석역 (2번 출구) 도보 10분 소요
                                    </p>
                                </div>
                                <div class="col-lg-12">
                                    <div id="map" style="width:100%;height:400px;"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </card>
            </div>
        </section>
    </div>
</template>
<script>
export default {
    name : 'location',
    data() {
        return {
        }
    },
    mounted() {
        // 네이버 지도 API 로드
        const script = document.createElement("script");
        script.src = "https://oapi.map.naver.com/openapi/v3/maps.js?ncpClientId=rh06rmaayq";
        script.async = true;
        script.defer = true;
        document.head.appendChild(script);

        script.onload = () => {
            // 네이버 지도 생성
            let map = new window.naver.maps.Map("map", {
                center: new window.naver.maps.LatLng(37.506021, 126.970589),
                zoom: 16,
                minZoom: 10,
                zoomControl: true,
                zoomControlOptions: { //줌 컨트롤의 옵션
                    position: naver.maps.Position.TOP_RIGHT
                }
            });
            // 마커 생성
            let marker = new naver.maps.Marker({
                position: new naver.maps.LatLng(37.506021, 126.970589),
                map: map
            });
        };
    }
}

</script>
<style>
    .btn-ad{
        color: #9e1c4e;
        border: 1px solid #9e1c4e;
        padding: 3px 10px;
        font-size: 15px;
        display: inline-block;
        text-align: center;
        position: relative;
    }

    .btn-naver{
        color: #FFF;
        border: 1px solid darkgray;
        border-radius: 1em;
        padding: 3px 10px;
        font-size: 15px;
        display: inline-block;
        text-align: center;
        position: relative;
    }

    .bg-line-4 {
        background-color: #00A9E0;
    }

    .bg-line-9 {
        background-color: #8C8279;
    }
</style>